import { useEffect, useState } from "react";
import { auth } from "../firebase";
import { doc, setDoc, deleteDoc, collection, getDocs, query, orderBy } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { db } from "../firebase";
import drawerIcon from "../assets/nav_icon/drawer_icon.png";
import gridIcon from "../assets/nav_icon/grid_icon.png";
import filterIcon from "../assets/nav_icon/filter.png";
import filterIconActive from "../assets/nav_icon/filter_active.png";
import updownIcon from "../assets/nav_icon/updown_icon.png";
import updownIconActive from "../assets/nav_icon/updown_icon_active.png";
import partIcon from "../assets/nav_icon/part_icon.png";
import fullIcon from "../assets/nav_icon/full_icon.png";
import favIcon from "../assets/img/fav.png";
import favIconActive from "../assets/img/fav_active.png";
import TrainIcon from "../assets/img/train.png";
import TopNav from "../components/TopNav";
import { useNavigate } from "react-router-dom";
import "../App.css";

function Home() {
  const [isDrawerView, setIsDrawerView] = useState(true);
  const [filterActive, setFilterActive] = useState(false);
  const [sortActive, setSortActive] = useState(false);
  const [viewFull, setViewFull] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [user, setUser] = useState(null);
  const [favorites, setFavorites] = useState({});
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        const favSnap = await getDocs(
          collection(db, `users/${currentUser.uid}/favourite`)
        );
        const favData = {};
        favSnap.docs.forEach((doc) => {
          favData[doc.id] = true;
        });
        setFavorites(favData);
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const fetchJobs = async () => {
        setLoading(true);
        try {
          const q = query(
            collection(db, "items"),
            orderBy("uploaded_date", sortActive ? "asc" : "desc")
          );
          const snapshot = await getDocs(q);
          const jobList = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setJobs(jobList);
        } catch (error) {
          console.error("Error fetching jobs:", error);
        } finally {
          setLoading(false);
        }
      };
      
  
    fetchJobs();
  }, [sortActive]);
  

  const handleSearch = async () => {
    const q = query(collection(db, "items"));
    const snapshot = await getDocs(q);
    const filtered = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(job => job.name?.toLowerCase().includes(searchText.toLowerCase()) || job.desc?.toLowerCase().includes(searchText.toLowerCase()));
    setJobs(filtered);
  };

  const toggleFavorite = async (itemId) => {
    if (!user) return alert("Please log in to favorite jobs.");
    const favRef = doc(db, `users/${user.uid}/favourite/${itemId}`);

    if (favorites[itemId]) {
      await deleteDoc(favRef);
      setFavorites((prev) => {
        const updated = { ...prev };
        delete updated[itemId];
        return updated;
      });
    } else {
      await setDoc(favRef, { savedAt: new Date() });
      setFavorites((prev) => ({ ...prev, [itemId]: true }));
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate();
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  };

  const filteredJobs = viewFull
    ? jobs.filter((job) => job.type === "Full Time")
    : jobs.filter((job) => job.type === "Part Time");

  return (
    <div className="home-container">
      <TopNav />
      <div className="option-tab">
        <img
          src={isDrawerView ? gridIcon : drawerIcon}
          alt="Layout Toggle"
          className="icon-btn"
          onClick={() => setIsDrawerView(!isDrawerView)}
        />
        <img
          src={filterActive ? filterIconActive : filterIcon}
          alt="Filter"
          className="icon-btn"
          onClick={() => setFilterActive(!filterActive)}
        />
        <img
          src={sortActive ? updownIconActive : updownIcon}
          alt="Sort"
          className="icon-btn"
          onClick={() => setSortActive(!sortActive)}
        />
        <img
          src={viewFull ? fullIcon : partIcon}
          alt="View Mode"
          className="icon-btn"
          onClick={() => setViewFull(!viewFull)}
        />
      </div>

      {filterActive && (
        <div className="search-bar-container">
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search jobs by name or description"
            className="search-input"
          />
          <button className="auth-btn" onClick={handleSearch}>Search</button>
        </div>
      )}

      <p className="filter-status">
        {viewFull ? "Showing: Full Time Jobs" : "Showing: Part Time Jobs"}
      </p>

      {loading ? (
  <div className="loader-container">
    <div className="loader"></div>
  </div>
) : (
  <div className={`job-list ${isDrawerView ? "list-view" : "grid-view"}`}>
    {filteredJobs.map((job) => (
      <div key={job.id} className="job-tile" style={{ cursor: "pointer" }}>
        <img
          src={job.image || "/no_image.png"}
          onClick={() => navigate(`/item/${job.id}`)}
          alt="job"
          className="job-image"
        />
        <div className="job-info">
          <div>
            <h3 className="job-title">{job.name}</h3>
            <div className="area_section">
              <img src={TrainIcon} alt="train_icon" className="train_icon" />
              <p className="job-location">{job.place}</p>
            </div>
          </div>
          <p className="job-date">{formatDate(job.uploaded_date)}</p>
          <button
            className="fav-btn"
            onClick={() => toggleFavorite(job.id)}
            title="Add to Favorites"
          >
            <img
              src={favorites[job.id] ? favIconActive : favIcon}
              alt="Favorite Icon"
              className="fav-icon"
            />
          </button>
        </div>
      </div>
    ))}
  </div>
)}


    </div>
  );
}

export default Home;
